<div class="dialog-overlay d-overlay">

  <div
    class="dialog"
    role="dialog"
    aria-modal="true"
    aria-labelledby="dialogtitle"
    tabindex="-1"
  >

    <!-- =====================================================
         HEADER
    ====================================================== -->
    <div class="dialog-header">

      <div class="dialog-icon">
        <i class="pi pi-exclamation-triangle"></i>
      </div>

      <div class="dialog-heading">

        <div class="dialog-title-wrapper">
          <h5 id="dialogtitle">
            {{ title }}
          </h5>

          <button
            type="button"
            class="dialog-close"
            aria-label="Close"
            (click)="Cancel()"
          >
            <i class="pi pi-times"></i>
          </button>
        </div>

        <span class="dialog-subtitle">
          Please review this action before continuing.
        </span>

      </div>

    </div>

    <!-- =====================================================
         BODY
    ====================================================== -->
    <div class="dialog-body">

      <div
        class="dialog-message"
        [innerHTML]="message"
      ></div>

    </div>

    <!-- =====================================================
         FOOTER
    ====================================================== -->
    <div class="dialog-footer">

      <button
        type="button"
        class="btn btn-cancel"
        (click)="Cancel()"
      >
        <span>{{ btnCancelText }}</span>
      </button>

      <button
        type="button"
        class="btn btn-confirm"
        (click)="Confirm()"
      >
        <i class="pi pi-check"></i>
        <span>{{ btnOkText }}</span>
      </button>

    </div>

  </div>

</div>
